export default __webpack_public_path__ + "fonts/Gotham-Medium.b3d369ace02d2e27aeb6f8e01d89af65.woff";